const timeStringToFloat = (time) => {
    const hoursMinutes = time.split(/[.:]/);
    const hours = parseInt(hoursMinutes[0], 10);
    const minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0;
    return hours + minutes / 60;
};

const convertFloatToTime = (number) => {
    // Check sign of given number
    let sign = (number >= 0) ? 1 : -1;

    // Set positive value of number of sign negative
    number *= sign;

    // Separate the int from the decimal part
    let hour = Math.floor(number);
    let decimalPart = number - hour;

    const min = 1 / 60;
    // Round to nearest minute
    decimalPart = min * Math.round(decimalPart / min);

    let minute = `${Math.floor(decimalPart * 60)}`;

    // Add padding if need
    if (minute.length < 2) {
        minute = `0${minute}`;
    }

    if (hour < 10) {
        hour = `0${hour}`;
    }

    // Add Sign in final result
    sign = sign === 1 ? "" : "-";

    // Concat hours and minutes
    return `${sign + hour}:${minute}`;
};

const convertTime12to24 = (time12h) => {
    const [time, modifier] = time12h.split(" ");

    // eslint-disable-next-line prefer-const
    let [hours, minutes] = time.split(":");

    if (hours === "12") {
        hours = "00";
    }

    if (modifier === "PM") {
        hours = parseInt(hours, 10) + 12;
    }

    return `${hours}:${minutes}`;
};

const convertTime12to24New = (time12h) => {
    const [time, modifier] = time12h.split(" ");

    // eslint-disable-next-line prefer-const
    let [hours, minutes] = time.split(":");

    if (hours === "12") {
        hours = "00";
    }
    if (hours.length === 1) {
        hours = `0${hours}`;
    }

    if (modifier === "PM") {
        hours = parseInt(hours, 10) + 12;
    }

    return `${hours}:${minutes}`;
};
const convert24To12 = (time) => {
    // Check correct time format and split into components
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) { // If time format correct
        time = time.slice(1);  // Remove full string match value
        time[5] = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(""); // return adjusted time or original string
}

export {
    timeStringToFloat,
    convertFloatToTime,
    convertTime12to24,
    convertTime12to24New,
    convert24To12
};
